import React, { useMemo } from "react";
import { connect } from "react-redux";

const CategoryList = ({ products, category, favorites, onCategoryChange }) => {
  const categories = useMemo(() => {
    const safe = Array.isArray(products) ? products : [];
    return Array.from(
      new Set(safe.filter(p => p.category?.name).map(p => p.category.name))
    ).sort((a, b) => a.localeCompare(b));
  }, [products]);

  const favCount = favorites.length;
  const isLoggedIn = !!(() => { try { return localStorage.getItem("userEmail"); } catch { return null; } })();

  return (
    <div className="category-wrapper">
      {/* Прихований label для скрін-рідерів */}
      <label htmlFor="category-select" className="sr-only">
        Filter by category
      </label>
      <select
        id="category-select"
        value={category || "all"}
        onChange={(e) => onCategoryChange(e.target.value)}
        aria-label="Filter by category"
      >
        <option value="all">ALL</option>
        {isLoggedIn && (
          <option value="favorites">
            🧡 FAVORITES{favCount > 0 ? ` (${favCount})` : ""}
          </option>
        )}
        {categories.map(cat => (
          <option key={cat} value={cat}>{cat}</option>
        ))}
      </select>
    </div>
  );
};

const mapStateToProps = (state) => ({
  products: state.products,
  category: state.category,
  favorites: state.favorites,
});

export default connect(mapStateToProps)(CategoryList);
